// Main menu lets the user pick which level he'd like to play.

import { useLevelContext } from 'app/src/game/LevelContext';
import * as React from 'react';
import { Link } from 'react-router-dom';

export default function MainMenu(): React.ReactElement | null {
	const { allLevels, canPlayLevel, unlockAllLevels, resetUnlockedLevels } = useLevelContext();

	return (
		<div className="MainMenu">
			<h1 className="MainMenu-title">Select Level</h1>
			<div className="MainMenu-sections">
				{allLevels.map((section, sectionIndex) => {
					return (
						<div className="MainMenu-section" key={`section-${sectionIndex}`}>
							<h2 className="MainMenu-sectionTitle">{section.title}</h2>
							<div className="MainMenu-levels">
								{section.levels.map((level) =>
									canPlayLevel(level) ? (
										<Link
											to={`/level/${level}`}
											className="MainMenu-levelButton"
											key={`level-${level}`}
										>
											{level}
										</Link>
									) : (
										<div
											className="MainMenu-levelButton MainMenu-levelButton--disabled"
											key={`level-${level}`}
										>
											{level}
											<div className="MainMenu-lock" />
										</div>
									),
								)}
							</div>
						</div>
					);
				})}

				<div className="MainMenu-section" key="section-debug">
					<h2 className="MainMenu-sectionTitle">Debug</h2>
					<div className="MainMenu-levels">
						<button className="MainMenu-levelButton" onClick={resetUnlockedLevels}>
							Reset
						</button>
						<button className="MainMenu-levelButton" onClick={unlockAllLevels}>
							Unlock
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
